module.exports = __webpack_public_path__ + "static/media/livingroom-full.bd65686e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interiors/livingroom-full.jpg
// module id = 363
// module chunks = 0